import request from '@/utils/request'

let HelpApi = {

  /*帮助中心列表*/
  list(data) {
    return request._post('/shop/plus.help.Index/index', data);
},
/*添加帮助中心*/
add(data) {
    return request._post('/shop/plus.help.Index/add', data);
},
/*修改帮助中心*/
edit(data) {
    return request._post('/shop/plus.help.Index/edit', data);
},
/*删除帮助中心*/
del(data) {
    return request._post('/shop/plus.help.Index/del', data);
},
/*帮助中心详情*/
detail(data) {
  return request._post('/shop/plus.help.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.help.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.help.Setting/getSetting', data, errorback);
    },
}
export default HelpApi;



// WEBPACK FOOTER //
// ./src/api/help.js